import { useTranslation } from "react-i18next";
import PostCalendar from "../PostCalendar";
import { useState, useEffect } from "react";
import SocialEndpoints from "@serie3/mymediaplanner/Modules/Social/endpoints";
import crudApi from "@serie3/common/api/crudApi";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { Card } from "react-bootstrap";


const CalendarWrapper = ({ endpoint = `${SocialEndpoints.posts.schedule.index}`, hideTitle = false, hideCard = false }) => {
  const { t } = useTranslation();
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  // Source of truth for the current calendar date/month
  const [currentDate, setCurrentDate] = useState(new Date());

  const fetchPostsForDate = async (date) => {
    setLoading(true);
    const month = moment(date).format("MMYYYY"); // required format
    const route = `${endpoint}${month}`;

    await crudApi.getAll(
      route,
      setSchedules,
      SocialEndpoints.posts.scheduledDataField
    );
    setLoading(false);
  };

  // Load data whenever the month (currentDate) changes
  useEffect(() => {
    fetchPostsForDate(currentDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDate, endpoint]);

  // Called from PostCalendar via onNavigate
  const handleMonthChange = (newDate) => {
    // Normalize to first day of month to avoid weird dependencies
    const normalized = moment(newDate).startOf("month").toDate();
    setCurrentDate(normalized);
  };

  return (
    <>
      {!hideTitle && (
        <h4 className="page-section-header">
          <span className="page-section-header-icon" style={{ background: "rgba(81,210,140,0.12)" }}>
            <FontAwesomeIcon icon={faCalendarDays} style={{ color: "#51d28c" }} />
          </span>
          Calendar
        </h4>
      )}
      {hideCard ? (
        <div style={{ position: "relative" }}>
          {loading && <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.65)", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 12 }}>
            <span className="btn-spinner" style={{ width: 32, height: 32 }} />
          </div>}
          <PostCalendar
            schedules={schedules}
            setSchedules={setSchedules}
            date={currentDate}
            onMonthChange={handleMonthChange}
            onPlanSaved={() => fetchPostsForDate(currentDate)}
          />
        </div>
      ) : (
        <Card>
          <Card.Body style={{ padding: "24px", position: "relative" }}>
            {loading && <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.65)", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 12 }}>
              <span className="btn-spinner" style={{ width: 32, height: 32 }} />
            </div>}
            <PostCalendar
              schedules={schedules}
              setSchedules={setSchedules}
              date={currentDate}
              onMonthChange={handleMonthChange}
              onPlanSaved={() => fetchPostsForDate(currentDate)}
            />
          </Card.Body>
        </Card>
      )}
    </>
  );
};


export default CalendarWrapper;
